import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {AttachedDocument} from '../documents';

class OfferTemplate extends DomainObject {
  name;
  richText;
  locale;
  attachments;

  _relations = {
    attachments: [AttachedDocument]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      richText: observable,
      locale: observable,
      attachments: observable
    });

    this.merge(other);
  }
}

export default OfferTemplate;
